export enum ModeratorType {
  USER = 'user',
  USERGROUP = 'group'
}
